"use client";
import React, { useContext, useState, useEffect, useRef } from 'react';
import Image from 'next/image';
import "./../scss/header.scss";
import logo from './../../public/icons/logoupgrade.png';
import authorImg from './../../public/icons/notification-author.svg';
import flagImg from './../../public/icons/notification-flag.svg';
import articleImg from './../../public/icons/notification-article.svg';
import subscriptionImg from './../../public/icons/notification-subscription.svg';
import bellIcon from './../../public/icons/bell.svg';
import userAdmin from './../../public/icons/useradmin.svg';
import { useRouter } from 'next/navigation';
import profile from './../../public/icons/profile.svg';
import settingdrop from './../../public/icons/settingdrop.svg';
import logout from './../../public/icons/logout.svg';
import editIcon from './../../public/icons/edit-line.svg';
import flagIcon from './../../public/icons/flag.svg';
import Link from 'next/link';
import LoginPopUpPage from './LoginPopUp';
import UserContext from '@/context/userContext';
import deafultUser from './../../public/icons/default.svg';
import { showSuccess } from '@/utils/toast';

const Header = () => {
  const router = useRouter();
  const context = useContext(UserContext);
  const user = context.user;
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const dropdownRef = useRef(null);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showLearnDropdown, setShowLearnDropdown] = useState(false);
  const [showAuthDropdown, setShowAuthDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);

  // Close mobile menu whenever the route changes via Link clicks
  const closeMobileMenu = () => setShowMobileMenu(false);

  // Set client-side flag to prevent hydration mismatch
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Handle click outside to close popup
  useEffect(() => {
    const isAnyPopupOpen =
      showProfilePopup || showNotificationPopup || showLearnDropdown || showAuthDropdown || showSearch;

    if (!isAnyPopupOpen) return undefined;

    const handleClickOutside = (event) => {
      const target = event.target;
      if (!(target instanceof Node)) return;

      const targetElement = target instanceof Element ? target : target.parentElement;
      if (!targetElement) return;

      const menuElement = document.getElementById('menu');
      const notificationElement = document.getElementById('notification');
      const learnDropdownElement = document.getElementById('learn-dropdown');
      const learnTrigger = document.getElementById('learn-trigger');
      const authDropdownElement = document.getElementById('auth-dropdown');
      const authTrigger = document.getElementById('auth-trigger');

      if (showProfilePopup && menuElement && !targetElement.closest('#menu')) {
        setShowProfilePopup(false);
      }

      if (showNotificationPopup && notificationElement && !targetElement.closest('#notification')) {
        setShowNotificationPopup(false);
      }

      if (showLearnDropdown) {
        const clickedInsideLearnDropdown = Boolean(
          targetElement.closest('#learn-dropdown') || learnDropdownElement?.contains(targetElement)
        );
        const clickedLearnTrigger = Boolean(
          targetElement.closest('#learn-trigger') || learnTrigger?.contains(targetElement)
        );
        if (!clickedInsideLearnDropdown && !clickedLearnTrigger) {
          setShowLearnDropdown(false);
        }
      }

      if (showAuthDropdown) {
        const clickedInsideAuthDropdown = Boolean(
          targetElement.closest('#auth-dropdown') || authDropdownElement?.contains(targetElement)
        );
        const clickedAuthTrigger = Boolean(
          targetElement.closest('#auth-trigger') || authTrigger?.contains(targetElement)
        );
        if (!clickedInsideAuthDropdown && !clickedAuthTrigger) {
          setShowAuthDropdown(false);
        }
      }

      if (showSearch && !targetElement.closest('.header-search-overlay') && !searchQuery.trim()) {
        setShowSearch(false);
      }
    };

    document.addEventListener('pointerdown', handleClickOutside, true);

    return () => {
      document.removeEventListener('pointerdown', handleClickOutside, true);
    };
  }, [showProfilePopup, showNotificationPopup, showLearnDropdown, showAuthDropdown, showSearch, searchQuery]);

  const toggleProfilePopup = () => {
    setShowProfilePopup(true);
  };
  const toggleNotificationPopup = () => {
    setShowNotificationPopup(true);
  }
  const myLogOutFunction = (e) => {

    context.logout();
    showSuccess("You have been logged out successfully");
    setShowAuthDropdown(false);
    setShowProfilePopup(false);
    setTimeout(() => {
      router.push("/");
    }, 1000);
  }
  // Route to profile page
  const routeToProfilePage = () => {
    setShowProfilePopup(false);
    // router.push("/profile");
  }
  // Route to settings page
  const routeToSettingsPage = () => {
    setShowProfilePopup(false);
    // router.push("/settings");
  }

  const toggleAuthDropdown = () => {
    setShowAuthDropdown(!showAuthDropdown);
  }

  const openSearch = () => {
    closeMobileMenu();
    setShowSearch(true);
    setTimeout(() => searchInputRef.current?.focus(), 0);
  }

  const closeSearch = () => {
    setShowSearch(false);
    setSearchQuery("");
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (!q) {
      searchInputRef.current?.focus();
      return;
    }
    setShowSearch(false);
    setSearchQuery("");
    closeMobileMenu();
    router.push(`/search?q=${encodeURIComponent(q)}`);
  }



  return (
    <header className="fixed-top wrapper-header">
      <div className='wrapper-container h-border-bottom'>
        <div className='d-flex justify-content-between align-items-center'>
          {/* Logo  */}
          <div className="d-flex align-items-center gap-2 m-argin-logo">
            <a href="/" target="_blank" rel="noopener noreferrer">
              <div className="d-flex align-items-center gap-2 m-argin-logo" style={{ cursor: "pointer" }}>
                {/* <Image src={logo} alt="Invest in Energy" unoptimized={true} /> */}
                <img src="/icons/logoupgrade.png" alt="logo" />
              </div>
            </a>
          </div>

          {showSearch && (
            <div className="header-search-overlay">
              <form
                id="header-search"
                role="search"
                className="header-search-overlay-form"
                onSubmit={handleSearchSubmit}
              >
                <span className="header-search-overlay-icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.397h-.001l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85zm-5.242 1.156a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" />
                  </svg>
                </span>
                <input
                  ref={searchInputRef}
                  type="text"
                  className="header-search-overlay-input"
                  placeholder="What are you looking for?"
                  aria-label="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Escape') closeSearch();
                  }}
                />
              </form>
              <button
                type="button"
                className="header-search-close"
                aria-label="Close search"
                onClick={closeSearch}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            </div>
          )}

          <div className={`d-flex align-items-center gap-4 ${showSearch ? 'search-open' : ''}`}>
            {/* <!-- Notification Bell --> */}
            <div
              className={`header-links ${showMobileMenu ? 'mobile-open' : ''}`}
              aria-expanded={showMobileMenu}
              onClick={(e) => {
                // Auto-close mobile drawer when any nav link is tapped.
                // Skip the dropdown chevron toggles so they can still open
                // their nested menus without dismissing the drawer.
                if (!showMobileMenu) return;
                if (e.target.closest('a')) {
                  closeMobileMenu();
                }
              }}
            >
              <Link href={"/about-us"} prefetch={false} style={{ cursor: 'pointer', textDecoration: 'none', color: '#0C0C0C' }}><div className='text-link'>About Us</div></Link>
              <div
                style={{ cursor: 'pointer', position: 'relative', display: 'flex', alignItems: 'center', gap: '4px' }}
                id="learn-trigger"
              >
                <div className='text-link' style={{ color: '#0C0C0C', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <span onClick={() => { closeMobileMenu(); router.push("/learn-investing"); }}>Learn Investing</span>
                  <span onClick={() => setShowLearnDropdown(!showLearnDropdown)}>
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transform: showLearnDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease'
                      }}
                    >
                      <path d="M1 1L5 5L9 1" stroke="#31373A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </div>

                {showLearnDropdown && (
                  <div className="learn-dropdown" id="learn-dropdown">
                    <Link href="/strategies-valuation" prefetch={false} onClick={() => setShowLearnDropdown(false)} className="dropdown-item">Strategies & Valuation</Link>
                    <Link href="/investment-types" prefetch={false} onClick={() => setShowLearnDropdown(false)} className="dropdown-item">Investment Types</Link>
                    <Link href="/glossary" prefetch={false} onClick={() => setShowLearnDropdown(false)} className="dropdown-item">Glossary</Link>
                  </div>
                )}
              </div>
              <Link href={"/resources"} prefetch={false} style={{ cursor: 'pointer', textDecoration: 'none', color: '#0C0C0C' }}><div className='text-link'>Resources</div></Link>
              <Link href={"/market-insights"} prefetch={false} style={{ cursor: 'pointer', textDecoration: 'none', color: '#0C0C0C' }}><div className='text-link'>Market Insights</div></Link>
              <Link href={"/articles"} prefetch={false} style={{ cursor: 'pointer', textDecoration: 'none', color: '#0C0C0C' }}><div className='text-link'>Articles</div></Link>
              {/* <div className='text-link'>News</div> */}
              <Link href={"/all-news"} prefetch={false} style={{ cursor: 'pointer', textDecoration: 'none', color: '#0C0C0C' }}><div className='text-link'>News</div></Link>
              <Link href={"/contact-us"} prefetch={false} style={{ cursor: 'pointer', textDecoration: 'none', color: '#0C0C0C' }}><div className='text-link'>Contact Us</div></Link>
              {/* <div className='text-link'>Contact Us</div> */}
              <div style={{ position: 'relative' }}>
                {user ? (
                  <>
                    <div
                      id="auth-trigger"
                      className='user-avatar'
                      onClick={() => setShowAuthDropdown(true)} >
                      {user?.profile?.profile_picture ? (
                        <div className='user-avatar-icon'>
                          <Image src={user?.profile?.profile_picture} width={100} height={100} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} alt="Profile Picture" />
                        </div>
                      ) : (
                        <div className='user-avatar-icon'>
                          <Image src={deafultUser} alt="Default User" />
                        </div>
                      )}
                      <span className='user-name'>{user.name}</span>
                      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.32817 8.70667L11.6194 5.41334L12.5655 6.34667L8.32817 10.5867L4.09082 6.34667L5.0369 5.41334L8.32817 8.70667Z" fill="#31373A" />
                        <path d="M8.32817 8.70667L11.6194 5.41334L12.5655 6.34667L8.32817 10.5867L4.09082 6.34667L5.0369 5.41334L8.32817 8.70667Z" fill="black" fillOpacity="0.2" />
                      </svg>

                    </div>
                  </>
                ) : (
                  <button
                    id="auth-trigger"
                    className='btn-primary'
                    onClick={() => setShowLoginPopup(true)}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                  >
                    Sign Up
                  </button>
                )}
                {showAuthDropdown && (
                  <div className="auth-dropdown" id="auth-dropdown">
                    <Link href="/profile" onClick={() => setShowAuthDropdown(false)} className="dropdown-item">
                      <Image src={profile} alt="My Profile" width={18} height={18} />
                      My Profile
                    </Link>
                    {user?.is_author ? (
                      <Link href="/create-article" onClick={() => setShowAuthDropdown(false)} className="dropdown-item">
                        <Image src={editIcon} alt="Write An Article" width={18} height={18} />
                        Write an Article
                      </Link>
                    ) : (
                      <Link href="/become-author" onClick={() => setShowAuthDropdown(false)} className="dropdown-item">
                        <Image src={editIcon} alt="Become an Author" width={18} height={18} />
                        Become an Author
                      </Link>
                    )}
                    <Link href="/saved" className="dropdown-item">
                      <Image src={flagIcon} alt="Saved" width={18} height={18} />
                      Saved
                    </Link>
                    <div className="divider"></div>
                    <Link href="/editorial-guidelines" className="dropdown-item text-only">Editorial Guidelines</Link>
                    <Link href="/terms-and-conditions" className="dropdown-item text-only">Terms of Use</Link>
                    <Link href="/contact-us" className="dropdown-item text-only">Support</Link>
                    <div className="divider"></div>
                    <div className="dropdown-item logout-item" onClick={() => myLogOutFunction()}>
                      Sign Out
                    </div>
                  </div>
                )}
              </div>
              <button
                type="button"
                className="header-search-btn"
                aria-label="Open search"
                aria-expanded={showSearch}
                onClick={openSearch}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.397h-.001l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85zm-5.242 1.156a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" />
                </svg>
              </button>
            </div>
            <button
              className={`toggle-btn d-lg-none ${showMobileMenu ? 'is-open' : ''}`}
              aria-label="Toggle navigation menu"
              aria-expanded={showMobileMenu}
              onClick={() => setShowMobileMenu((prev) => !prev)}
            >
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
            </button>
            {showMobileMenu && (
              <div className="mobile-menu-backdrop d-lg-none" onClick={closeMobileMenu}></div>
            )}

            {/* Popup Menu - rendered outside dropdown but inside the ref container */}
            {showProfilePopup && (
              <>
                <div className='modal-position modal-bg'></div>
                <div className="menu" id="menu">
                  <Link href={'/profile'} target='_blank' prefetch={false} onClick={() => routeToProfilePage()} style={{ cursor: 'pointer' }}><Image src={profile} alt="" /> Profile</Link>
                  <Link onClick={routeToSettingsPage} href={'/settings'} target='_blank' prefetch={false} style={{ cursor: 'pointer' }}><Image src={settingdrop} alt="" /> Settings</Link>
                  <div className="divider"></div>
                  <a className="logout" onClick={myLogOutFunction} style={{ cursor: 'pointer' }}><Image src={logout} alt="" /> Logout</a>
                </div>
              </>
            )}
            {showNotificationPopup && (
              <>
                <div className='modal-position modal-bg'></div>
                <div className="notification" id="notification">
                  <div className='notification-header'>
                    <div className='left-text'>
                      Notifications
                    </div>
                    <div className='right-text'>
                      Mark all as read
                    </div>
                  </div>
                  <div className="notification-divider"></div>
                  <div className='notification-description'>
                    <div className="activity-tab d-flex align-items-start mb-3 isActive">
                      <div className='activity-tab-icon grayishblue-light text-danger me-3'>
                        <Image src={authorImg} alt="Crown Icon" />
                      </div>
                      <div>
                        <div className="main-list-header">New Author Application</div>
                        <div className="main-sub-list-header">Sarah Johnson submitted an application</div>
                        <div className='month-details'>2 Min ago</div>
                      </div>
                    </div>
                    <div className="activity-tab d-flex align-items-start mb-3">
                      <div className='activity-tab-icon red-light text-danger me-3'>
                        <Image src={flagImg} alt="Crown Icon" />
                      </div>
                      <div>
                        <div className="main-list-header">Comment Flagged</div>
                        <div className="main-sub-list-header">Comment requires moderation review</div>
                        <div className='month-details'>12 Min ago</div>
                      </div>
                    </div>
                    <div className="activity-tab d-flex align-items-start mb-3 isActive">
                      <div className='activity-tab-icon green-light text-danger me-3'>
                        <Image src={articleImg} alt="Crown Icon" />
                      </div>
                      <div>
                        <div className="main-list-header">Article Published</div>
                        <div className="main-sub-list-header">Solar Energy Trends 2024 is now live</div>
                        <div className='month-details'>23 Min ago</div>
                      </div>
                    </div>
                    <div className="activity-tab d-flex align-items-start mb-3">
                      <div className='activity-tab-icon yellow-ligth text-danger me-3'>
                        <Image src={subscriptionImg} alt="Crown Icon" />
                      </div>
                      <div>
                        <div className="main-list-header">Premium Subscription</div>
                        <div className="main-sub-list-header">Michael Chen upgraded to premium</div>
                        <div className='month-details'>2 hours ago</div>
                      </div>
                    </div>
                  </div>
                  <div className="notification-divider"></div>
                  <div className='notification-bottom' >
                    <span onClick={routeToNotificationPage}>View all notifications</span>
                  </div>
                  {/* {showLoginPopup && ( */}
                  {/* <LoginPopUpPage /> */}
                  {/* // )} */}
                </div>
              </>
            )}
            {showLoginPopup && (
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 99999, overflow: 'auto' }}>
                <LoginPopUpPage onClose={() => setShowLoginPopup(false)} initialScreen="join-invest" />
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header


